const putUrl = {
	editUser: '/user',
	editProduct: '/product',
	editCategory: '/category',
	addCategoryImages: '/category/addCategoryImages',

	editEnquiry: '/enquiry',
	updateSupplyAdminInterest: '/enquiry/supply-admin-interest',
	submitEnquiryQuote: '/enquiry/submitSupplierQuote',
	editEnquiryQuote: '/enquiry/editSupplierQuote',
	saveCostMetrics: '/enquiry/saveCostMetrics',

	submitBuyerQuote: '/enquiry/submitBuyerQuote',
	submitScrapSupplierQuote: '/enquiry/submitScrapSupplierQuote',

	editOrder: '/order',
	updateInvoice: '/order/updateInvoice',
	updateInvoiceV2: '/order/v2/updateInvoice',
	deleteInvoice: '/order/deleteInvoice',
	updatePaymentTermsAndTenure: '/order/updatePaymentTermsAndTenure',
	updateOrderCostMetrics: '/order/updateCostMetrics',
	updateReceiverDetails: 'order/updateReceiverDetails',

	editAuction: '/auction',
	submitBuyerBid: '/auction/submitBuyerQuote',
	editBuyerBid: '/auction/editBuyerQuote',
	submitSupplierBid: '/auction/submitSupplierQuote',
	updateLogistics: '/logistics/updateLogisticsRequests',
	submitLogisticsQuote: '/logistics/submitLogisticsQuote',
	editLogisticsQuote: '/logistics/editLogisticsQuote',
	editLogisticsOrder: '/logistics/editLogisticsOrder',
	deleteLogisticsInvoice: '/logistics/deleteInvoice',
	editEnquiryLogisticsQuote: '/logistics',

	updateMachine: '/machine',
	updateFactory: '/factory',

	updateFabricationOrder: '/factory/updateFabricationOrder',
	updateFabricationInvoice: '/factory/updateFabricationInvoice',
	updateFabricationRemainingInventory: '/factory/updateFabricationRemainingInventory',
	updateLogisticsPrices: '/logisticsPrices',
	updateInvoices: '/invoice',
	addOtherInvoiceDocuments: '/invoice/addOtherInvoiceDocuments',
	invoicePaymentAction: '/invoice-payment/invoice/action',
	invoicesPaymentAction: '/invoice-payment/invoices/action',
	attachInvoicesToPayment: '/invoice-payment/attachInvoices',
	cancelInvoicePayment: '/invoice-payment/cancel',

	// updateUserMapping: '/user/updateUserMapping',

	updateInvoiceTracker: '/order/trip',
	kycStatus: '/financials/kyc/kycStatus',
	updateLocation: '/financials/kyc/updateLocation',
	mergeUsers: '/user/mergeUsers',
	changeUserRole: '/user/changeUserRole',
	updateReportingManager: '/user/updateReportingManager',
	editBanner: '/banner/edit',
	editContent: '/content/editContent',

	addAddressToOrganisation: '/organisation/addAddressToOrganisation',
	addGstToOrganisation: '/organisation/addGstToOrganisation',
	changeOrgName: '/organisation/changeName',
	addSubsidiary: '/organisation/subsidiary',
	changeOrgPan: '/organisation/updatePan',
	updateDefaultAdmin: '/organisation/updateDefaultAdmin',
	requestKycUpdate: '/organisation/requestKycUpdate',
	acceptRoles: '/organisation/acceptRoles',
	requestRoles: '/organisation/requestRoles',
	removeRoleFromOrganisation: 'organisation/removeRoleFromOrganisation',
	mergeOrganisation: '/organisation/mergeOrganisations',
	updateSharePrices: '/organisation/updateSharePrices',
	blacklistOrganisation: '/organisation/blacklistOrganisation',
	updateOrganisationAddress: '/organisation/updateOrganisationAddress',

	editCommodity: '/commodity',
	uploadBuyerExportDocuments: '/order/uploadExportDocuments',

	addMessageToEnquiryJourney: '/journey/addMessageToEnquiry',
	fetchCompanyData: 'organisation/fetchCompanyData',
	updateIsTrader: 'organisation/updateIsTrader',
	udyamDetails: 'organisation/udyamDetails',
	updateRegion: '/organisation/updateRegion',
	updateAccountDetails: '/organisation/updateAccountDetails',
	updateOrganisation: '/organisation/updateOrganisation',

	editPaymentReceivables: '/payment-receivables/editRemarks',
	addremarkToPaymentReceivables: '/payment-receivables/addRemarks',
	changeStatusPaymentReceivables: '/payment-receivables/updateStatus',
	addPaymentToCollection: '/payment-receivables/addPaymentToCollection',

	updateLead: '/lead/',
	updateLeadStatus: '/lead/updateTaskStatus',
	addLeadTask: '/lead/addTask',
	updateTaskReminder: '/lead/updateTaskReminder',
	updateStatus: '/lead/updateStatus',
	assignLeadManager: '/lead/assignManager',
	addMeetingRemarks: '/lead/addMeetingRemarks',
	updateTarget: '/user/updateTarget',
	editFinancials: 'financials',
	UpdateFinancialsBusinessDetail: 'financials/updateBusinessDetail',
	editPdc: '/financials/editPdc',
	setInsuredLimit: '/financials/setInsuredLimit',
	addFinancialsRemark: 'financials/addRemark',
	setFinancialsFeedback: 'financials/setFeedback',
	dataCorrection: 'ledger/dataCorrection',

	editPunchOrder: '/punchOrder',

	editGlossary: '/glossary',

	updateCredditLimit: '/creditLimit',
	updateSpoAttachToEnquiry: '/supplierOrder/attachToEnquiry',
	updateSpoAttachToOrder: '/supplierOrder/attachToOrder',
	updateSpo: '/supplierOrder',

	updateOracleOrder: '/oracle/updateOrder',
	updateManageSpo: '/oracle/updateManageSpo',

	updateBankFacilities: '/probe42/updateBankFacilities',

	updateDisaptchInvoiceWeight: '/dispatchPlan/updateDispatchInvoiceWeight',
	addDispatchInvoice: '/extra/addDispatchInvoice',
	updateDispatchPlanStatus: '/dispatchPlan/updateDispatchPlanStatus',
	addVehicleDriverDetails: '/dispatchPlan/addVehicleDriverDetails',
	updateVehicleDriverDetailsStatus: '/dispatchPlan/updateVehicleDriverDetails',
	updateVehicleDetails: '/dispatchPlan/updateVehicleDetails',
	updateDispatchPlanStartDate: '/dispatchPlan/updatePlanStartDate',
	updateReadyForInvoicing: '/dispatchPlan/updateReadyForInvoicing',
	updateVehicleDelayStatus: '/dispatchPlan/updateVehicleDelayStatus',

	updateCranFinanceAnalyst: '/cranReport/updateFinanceAnalyst',
	updateRecommendedCreditLimit: '/cranReport/updateRecommendedCreditLimit',
	updateApprovedCreditLimit: '/cranReport/updateApprovedCreditLimit',
	updateInspectionReport: '/cranReport/saveInspectionReport',
	addVoterDetails: '/cranReport/voterDetails',
	addVotingOptions: '/cranReport/votingOptions',

	updateSpoStatus: '/supplierOrder/updateStatus',
	pushSpoToOracle: '/supplierOrder/pushToOracle',

	creditApprovalAction: '/creditApproval/approval/action',
	creditApprovalActionAll: '/creditApproval/approval/actionAll',
}

export default putUrl
